<div class="row">
    <div class="col-md-12 version-popup" [ngClass]="{'version-popup': isMobile == true}">
        <span class="version-msg">A new version of Hthai Clienteling App is available. </span>
        <span class="version-refresh" (click)="refreshVersion()">REFRESH</span>
        <span class="version-times" (click)="closeSnackBar()"><i class="fa fa-times "></i></span>
    </div>
</div>